import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import Loader from '../components/Loader';
import { authState } from '../recoil';
import { orange } from '../utils/common';

const Redirect = () => {
  const navigate = useNavigate();
  const [_, setAuthorizationCode] = useRecoilState(authState);

  const [searchParams] = useSearchParams();
  const authorization_code = searchParams.get('code');

  useEffect(() => {
    authorization_code && setAuthorizationCode(authorization_code);
  }, [authorization_code]);

  useEffect(() => {
    navigate('/home');
  }, []);

  return (
    <div>
      <Loader color={orange} size={50} />
    </div>
  );
};

export default Redirect;
